module.exports = __webpack_public_path__ + "static/img/qrcoder.b810ad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/qrcoder.png
// module id = rhCc
// module chunks = 18